var ws_type = location.protocol == "https:" ? "wss://" : "ws://";
console.log(ws_type);
import { useIpadHuntStore } from "@/stores/apps/ipad_hunt";
import { useCluedoAIStore } from "@/stores/apps/cluedo_ai";
import { useCollaboStore } from "@/stores/apps/collabo";
import { useMusicalBingoStore } from "@/stores/apps/musical_bingo";
import { useCommonSenseStore } from "@/stores/apps/common_sense";
import { reconnectGameData } from "./reconnect";
import { useEventsStore } from "@/stores/apps/events";
const ip_port = import.meta.env.VITE_APP_IP_PORT;

let try_reconnect = 0;

const startSocket = (
	url: string,
	onMsgCallback: (arg: string) => void,
	options?: { reconnect?: boolean }
) => {
    let reconect = 0;
    const shouldReconnect = options?.reconnect !== false;
    let socketEvent = new WebSocket(ws_type + ip_port + "ws/" + url);
    console.log(url);
    if( url.includes("IpadHunt/"))
    {
        const iapdStore = useIpadHuntStore();
        iapdStore.ws = socketEvent;
    }
    if( url.includes("cluedoAi/"))      
    {
        const cluedoAIStore = useCluedoAIStore();
        cluedoAIStore.ws = socketEvent;
    }
    if( url.includes("collabo/"))      
    {
        const collaboStore = useCollaboStore();
        collaboStore.ws = socketEvent;
    }
    if (url.includes("CommonSense/")) {
        const commonSenseStore = useCommonSenseStore();
        commonSenseStore.ws = socketEvent;
    }
    socketEvent.onopen = function (e) {
        console.log("[open] Conexión establecida");
        console.log(try_reconnect);
        // Set up ping interval
        const pingInterval = setInterval(() => {
            if (socketEvent.readyState === WebSocket.OPEN) {
                socketEvent.send(JSON.stringify({ type: "data" }));
            }
        }, 10000);

        // Clear interval when socket closes
        socketEvent.addEventListener('close', () => {
            clearInterval(pingInterval);
        });

        if (try_reconnect == 1) {
            try_reconnect = 0;
            //const eventStore = useEventsStore();
            //reconnectGameData(eventStore.eventSelected.activity.code as string, eventStore.eventSelected.api_key as string, eventStore.eventSelected.gmView as boolean );
        }
    };

    // set ping evr y 3 secodns
    

    socketEvent.onclose = function (event) {
        if (!shouldReconnect) {
            return;
        }
        setTimeout(function () {
            try_reconnect = 1;
            startSocket(url, onMsgCallback);
            reconect++;
            if (reconect == 9) {
                reconect = 0;
            }
        }, 1000);
    };

    socketEvent.onmessage = function (event) {
        const dataWs = JSON.parse(event.data);
        //console.log(event.data);
        onMsgCallback(event.data);
    };

    socketEvent.onerror = function (error) {
        if (shouldReconnect) {
            try_reconnect = 1;
        }
        console.log(`[error]`);
    };

    return socketEvent;
};



export { startSocket };
